module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Blueprint Brilliance","short_name":"Blueprint Brilliance","start_url":"/","background_color":"#262626","theme_color":"#f2f2f2","display":"standalone","icon":"src/images/BB_favicon.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"6a7b034337ca195a509a487130c2513b"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
